import { createLocalApisClient } from "@dpdgroupuk/mydpd-app";

export default window.localApisClientProvider ||
  createLocalApisClient({
    handleElectronInjection: true,
  });
